import React, { useEffect, useState } from 'react'
import { createFollowerData } from '@/api/followers';
import SolidButton from '@/components/ui/Buttons/SolidButton';
import { useAuthContext } from '@/context/auth/useAuthContext';
import { enqueueSnackbar } from 'notistack';
import PostAvatar from '@/components/ui/PostAvatar';
import Link from 'next/link';
import { getAllUserFollowing } from '@/api/posts';
import { getUserById, getUserLastIpByUserId } from '@/api/user';
import { useTranslations } from "@/lib/static-intl";
import { set } from 'date-fns';
import { buildCurrentUserProfilePath } from '@/constants/routes';

const ContentUser = ({
    postUser,
    onUnfollow,
    setUsers,
    currentUserFollowing,
    setEffectTrigger = { setEffectTrigger }
}) => {
    const t = useTranslations("user_profile")
    const t1 = useTranslations("explore.explore_post_details");

    const { user, openLoginModal } = useAuthContext();
    const [loader, setLoader] = useState(false);
    const [currentUserIpLocation, setCurrentUserIpLocation] = useState(null);
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);
    const profilePath = buildCurrentUserProfilePath(postUser?.username, postUser?.id);

    const fetchUserProfileById = async (userId) => {
        try {
            setLoading(true);
            const response = await getUserById(userId);
            console.log(response);
            if (response?.id) {
                setUserData(response);
            }
        } catch (error) {
            enqueueSnackbar(
                error?.response?.data?.message ||
                error?.message ||
                apiT("error message"),
                {
                    variant: "error",
                }
            );
        } finally {
            setLoading(false);
        }
    }

    const followThisUser = async (userIdToBeFollowed) => {

        if (!user) {
            openLoginModal();
            return;
        }
        if (!userIdToBeFollowed) return;

        try {
            setLoader(true);
            const payload = {
                followingId: userIdToBeFollowed,
                followerId: user?.userId,
            };
            const response = await createFollowerData(payload);

            setUsers((prev) => {
                const updatedUsers = [...prev];
                const userToBeFollowed = updatedUsers.find((user) => user.id == userIdToBeFollowed);
                if (userToBeFollowed?.followers) {
                    if (!userToBeFollowed.followers?.find((_f) => _f.id == response.id)) {
                        userToBeFollowed.followers.push(response)
                        userToBeFollowed._count.followers = userToBeFollowed.followers.length;
                    }
                }

                return updatedUsers;
            })
        } catch (error) {
            enqueueSnackbar(
                error?.response?.data?.message || error?.message || "Error",
                {
                    variant: "error",
                }
            );
        } finally {
            setLoader(false);
            setEffectTrigger((prev) => prev + 1);
        }
    };

    function isFollowing(contentUserId) {
        if (!contentUserId || !Array.isArray(currentUserFollowing)) return false;
        return currentUserFollowing.some((following) => following.userId === contentUserId);
    }

    const fetchUserLastIp = async (userId) => {
        try {
            // setLoader(true);
            const response = await getUserLastIpByUserId(userId);
            console.log(response);
            if (Array.isArray(response) && response[0]?.ipLocation) {
                const reformattedIpLocations =
                    `${response[0]?.ipLocation?.split(",")?.reverse()[1]?.trim()}` +
                    `, ${response[0]?.ipLocation?.split(",")?.reverse()[0]?.trim()}`;
                if (reformattedIpLocations)
                    setCurrentUserIpLocation(reformattedIpLocations);
            }
        } catch (error) {
            // enqueueSnackbar(
            //   error?.response?.data?.message ||
            //   error?.message ||
            //   apiT("error message"),
            //   { variant: "error" }
            // );
        }
    };

    useEffect(() => {
        fetchUserLastIp(postUser?.id);
        fetchUserProfileById(postUser?.id);
    }, [])

    return !loading && (
        <div key={postUser?.id} className="flex items-center justify-between w-full p-4">
            <div className="flex items-center space-x-3">
                <div className="w-12 h-12 overflow-hidden cursor-pointer">
                    <Link target='_blank' href={profilePath}>
                        <PostAvatar className={"!min-w-8 !h-8"} src={postUser.profilePicture} />
                    </Link>
                </div>
                <div className="flex flex-col">
                    <div className='flex sm:items-center flex-col sm:flex-row'>
                        <div className='flex items-center gap-2'>
                            <Link target='_blank' href={profilePath}>
                                <h2 className="text-base font-semibold dark:text-dark_primary_label text-gray-900 cursor-pointer">{postUser?.name}</h2>
                            </Link>
                            <span className="text-sm dark:text-dark_secondary_label text-light_secondary_label sm:ml-2">{postUser?.username}</span>
                        </div>
                        {
                            userData?.location && (
                                <>
                                    <span className="text-sm dark:text-dark_secondary_label text-light_secondary_label sm:ml-2 hidden sm:block">|</span>
                                    <span className="text-sm dark:text-dark_secondary_label text-light_secondary_label sm:ml-2">{t("last_location")}: {currentUserIpLocation}</span>
                                </>
                            )
                        }
                    </div>
                    <p className=' dark:text-dark_secondary_label text-light_secondary_label'>{userData?.bio}</p>
                    <div className="flex items-center gap-4">
                        <span className="text-sm dark:text-dark_secondary_label text-light_secondary_label">{postUser?._count?.followers} <span>{t1("followers")}</span></span>
                        <span className="text-sm dark:text-dark_secondary_label text-light_secondary_label">{postUser?._count?.following} <span>{t1("followings")}</span></span>
                        <span className="text-sm dark:text-dark_secondary_label text-light_secondary_label flex flex-col sm:flex-row">{postUser?._count?.likes} {" "}<span className='ml-0 sm:ml-1'>{t1("likes_and_fav")}</span></span>
                    </div>
                </div>
            </div>

            <div
                className={`${user?.userId === postUser?.id && "invisible"
                    }`}
            >
                {isFollowing(postUser.id) ? (
                    <SolidButton
                        className={`!py-1.5 transition ease-in-out !bg-gray-400 cursor-pointer ${loader && "cursor-not-allowed opacity-60"
                            }`}
                        onClick={onUnfollow}
                        loading={loader}
                        disabled={loader}
                    >
                        Unfollow
                    </SolidButton>
                ) : (
                    <SolidButton
                        className={`!py-1.5 transition ease-in-out cursor-pointer ${loader && "cursor-not-allowed opacity-60"
                            }`}
                        onClick={() => followThisUser(postUser?.id)}
                        loading={loader}
                        disabled={loader}
                    >
                        Follow
                    </SolidButton>
                )}
            </div>
        </div>
    )
}

export default ContentUser
